<template>
  <base-modal
    modal-id="delivery-time-table"
    class="dine-add-card"
    modalSize="lg"
    centered
  >
    <template v-slot:header>
      <slot
        name="header"
        v-if="isModuleEnable(CONST.MODULE_FUTURE_ORDERS) || !domainBasedBrand"
      >
        <div v-if="currentDateTime">
          <p class="modal-title mb-0">
            {{ _T('Select a delivery date and time') }}
            <small v-if="time_slots.length">
              (
              <span v-if="!currentStore.delivery_hours.all_day_long"
                >{{ _T('Store delivery timing:') }} &nbsp;
                {{
                  date_time_format(
                    currentDateTime.current_date +
                      ' ' +
                      currentStore.delivery_hours.opens_at,
                    'hh:mm A'
                  )
                }}
                {{ _T(' - ') }}
                {{
                  date_time_format(
                    currentDateTime.current_date +
                      ' ' +
                      currentStore.delivery_hours.closes_at,
                    'hh:mm A'
                  )
                }}
              </span>
              <span v-else>
                {{ _T('We delivery 24*7') }}
              </span>
              )
            </small>
          </p>
          <p class="text-danger" v-if="!time_slots.length">
            <!--<span v-if="!currentStore.delivery_hours.all_day_long">
              {{ _T('We deliver between') }}
              {{ date_time_format(currentDateTime.current_date + ' ' +currentStore.delivery_hours.opens_at, "hh:mm A") }}
              {{ _T(' to ') }}
              {{ date_time_format(currentDateTime.current_date + ' ' +currentStore.delivery_hours.closes_at, "hh:mm A") }}
              {{ _T(', please schedule it for later.') }}
            </span>-->
            <span v-if="days_to_delivery">
              {{ _T('Your order will take') }} &nbsp;
              <b>{{
                days_to_delivery > 1
                  ? days_to_delivery + ' days'
                  : days_to_delivery + ' day'
              }}</b>
              &nbsp;{{ _T('to deliver please select future date time slot') }}
            </span>
            <span v-else>
              &nbsp;{{
                _T(
                  '!Sorry no more delivery for today, please schedule it for later'
                )
              }}&nbsp;
            </span>
          </p>
          <p class="text-danger" v-if="!is_store_open">
            <span>
              {{
                _T(
                  'Store delivery is not started yet, please schedule it for later'
                )
              }}
            </span>
          </p>
        </div>
      </slot>
    </template>
    <template v-slot:modal-body>
      <div
        class="modal-body pt-0"
        v-if="isModuleEnable(CONST.MODULE_FUTURE_ORDERS) || !domainBasedBrand"
      >
        <div
          class="date-schedule d-flex justify-content-between"
          v-if="deliveryDate"
        >
          <button @click="swipeLeftMonth" class="btn-style-arrow">
            <img alt="move" :src="right_arrow" height="35" width="35" />
          </button>
          <ul ref="slotMonth" class="date-card mx-2">
            <li
              :class="{ active: month.name === current_month }"
              @click="activeMonth(month)"
              v-for="(month, index) of months_arr"
              :key="`${month.name}-${index}`"
            >
              <h4 class="month_date">{{ _T(month.name) }}</h4>
              <h6 class="month_date">{{ month.year }}</h6>
            </li>
          </ul>
          <button @click="swipeRightMonth" class="btn-style-arrow">
            <img alt="move" :src="left_arrow" height="35" width="35" />
          </button>
        </div>
        <div
          class="date-schedule d-flex justify-content-between"
          v-if="deliveryDate.length"
        >
          <button @click="swipeLeft" class="btn-style-arrow">
            <img alt="move" :src="right_arrow" height="35" width="35" />
          </button>
          <ul ref="content" class="date-card mx-2">
            <li
              :class="{
                active: date._date == activeDay && days_to_delivery <= index,
              }"
              @click="activeDate(date)"
              v-for="(date, index) of deliveryDate"
              :key="`${date.day}-${index}`"
            >
              <h4>{{ _T(date.day) }}</h4>
              <h2>{{ date.dt }}</h2>

              <!--<small class="month_date"> {{ date.month }}</small>-->
            </li>
          </ul>
          <button @click="swipeRight" class="btn-style-arrow">
            <img alt="move" :src="left_arrow" height="35" width="35" />
          </button>
        </div>
        <!--<div class="desired-time-selection">
          &lt;!&ndash;<h4>{{ _T('Desired Delivery Time') }}</h4>&ndash;&gt;
          <div class="box-checkbox">
            <ul class="row justify-content-center">
              <li class="col-sm-5" v-if="time_slots.length">
                <label
                    @click="futureDelivery(false)"
                    for="chk-ani"
                    class="delivery-label"
                >
                  <input
                      class="radio_animated"
                      id="chk-ani"
                      type="radio"
                      name="rdo-ani"
                      checked
                  />
                  <span>{{ _T('As soon as possible') }}</span>
                </label>
              </li>
              <li class="col-sm-5 margin-mobile">
                <label
                    @click="futureDelivery(true)"
                    for="chk-ani1"
                    class="delivery-label"
                >
                  <input
                      class="radio_animated"
                      id="chk-ani1"
                      type="radio"
                      name="rdo-ani"
                  />
                  <span>{{ _T('Select time slot') }}</span>
                </label>
              </li>
            </ul>
          </div>
        </div>-->
        <div
          class="date-schedule d-flex justify-content-center desired-time"
          v-if="future_delivery && !time_slots.length"
        >
          <h5 v-if="days_to_delivery">
            {{ _T('Your order will take ') }}
            <b>{{
              days_to_delivery > 1
                ? days_to_delivery + ' days'
                : days_to_delivery + ' day'
            }}</b>
            &nbsp;{{ _T('to deliver please select future date time slot') }}
          </h5>
          <h5 v-else>
            {{
              _T(
                '!Sorry no more delivery for today, please schedule it for later'
              )
            }}
          </h5>
        </div>
        <div
          class="date-schedule d-flex justify-content-between desired-time"
          v-else-if="deliveryDate.length && future_delivery"
        >
          <button @click="swipeLeftTime" class="btn-style-arrow">
            <img alt="move" :src="right_arrow" height="35" width="35" />
          </button>

          <div class="box-checkbox">
            <ul ref="slotTiming" class="timing-checkbox row w-90 mx-auto">
              <li
                class="time_box_slot"
                v-for="(slot, index) in time_slots"
                :key="index"
                :class="{ active: slot.time_to == active_slot.time_to }"
                @click="activeTime(slot)"
              >
                <label :for="'chk_ani' + index" class="time-labels">
                  <input
                    class="radio_animated"
                    :id="'chk_ani' + index"
                    type="radio"
                    name="rdo-ani1"
                  />
                  <span>{{ slot.time_to }}</span>
                  <!--<span class="p-0">-</span>
                  <span>{{ slot.time_to }}</span>-->
                </label>
              </li>
            </ul>
          </div>

          <button @click="swipeRightTime" class="btn-style-arrow">
            <img alt="move" :src="left_arrow" height="35" width="35" />
          </button>
        </div>
        <div
          class="date-schedule d-flex justify-content-center desired-time"
          v-else
        >
          <h5 v-if="time_slots.length">
            {{ _T('Your order will delivery in around') }}
            <b>{{ deliveryTime(currentStore) }}</b>
          </h5>
          <h5 v-else>
            {{
              _T(
                '!Sorry no more delivery for today, please schedule it for later'
              )
            }}
          </h5>
        </div>
        <h5 class="text-danger text-center" v-if="error">
          {{ _T(error) }}
        </h5>
      </div>
      <div class="header pb-4" v-else>
        <b v-if="!currentStore.delivery_hours.all_day_long" class="text-danger">
          {{
            _T('Store is closed for today. We are open again tomorrow between')
          }}
          &nbsp; (
          {{
            date_time_format(
              currentDateTime.current_date +
                ' ' +
                currentStore.delivery_hours.opens_at,
              'hh:mm A'
            )
          }}
          {{ _T(' - ') }}
          {{
            date_time_format(
              currentDateTime.current_date +
                ' ' +
                currentStore.delivery_hours.closes_at,
              'hh:mm A'
            )
          }}
          )
        </b>
      </div>
    </template>
    <template v-slot:modal-footer>
      <div
        class="modal-footer justify-content-center"
        v-if="isModuleEnable(CONST.MODULE_FUTURE_ORDERS) || !domainBasedBrand"
      >
        <button
          type="button"
          class="btn btn-outline btn-block"
          data-dismiss="modal"
          @click="$bvModal.hide('delivery-time-table')"
        >
          {{ _T('Cancel') }}
        </button>
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="setFutureDateTime"
        >
          {{ _T('Apply') }}
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BaseModal from '@/components/Modals/BaseModal.vue'
export default {
  name: 'DeliveryTimeModal',
  components: {
    BaseModal,
  },
  data: () => ({
    right_arrow: document.body.classList.contains('body-rtl')
      ? '/img/right.png'
      : '/img/left_arrow.png',
    left_arrow: document.body.classList.contains('body-rtl')
      ? '/img/left_arrow.png'
      : '/img/right.png',
    deliveryDate: [],
    days_to_delivery: 0,
    is_store_open: true,
    hoursCalculation: {},
    time_slots: [],
    future_delivery: true,
    activeDeliveryDate: '',
    days_in_month: 0,
    activeDay: '',
    error: '',
    active_slot: '',
    current_month: undefined,
    current_year: undefined,
    months: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'June',
      'July',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec',
    ],
  }),
  watch: {
    currentStore: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.getInterval()
          })
        }
      },
    },
  },
  computed: {
    ...mapGetters([
      'currentStore',
      '_T',
      'deliveryTime',
      'convertDateTimeTimezone',
      'future_order_format_date_time',
      'date_time_format',
      'isModuleEnable',
      'domainBasedBrand',
      'currentDateTime',
    ]),
    months_arr() {
      let new_months = []
      let next_year_months = []
      let current_month = new Date().getMonth()
      let current_year = new Date().getFullYear()
      this.months.forEach((month, index) => {
        if (index >= current_month)
          new_months.push({ name: month, year: current_year })
        else
          next_year_months.push({
            name: month,
            year: parseInt(current_year) + 1,
          })
      })
      return [...new_months, ...next_year_months]
    },
  },
  methods: {
    activeTime(slot) {
      this.active_slot = slot
    },
    activeMonth(month) {
      this.current_month = month.name
      this.deliveryDate = []
      let current_month_index = this.months.indexOf(month.name)
      this.current_year = month.year
      this.days_in_month = new Date(
        month.year,
        current_month_index + 1,
        0
      ).getDate()
      this.days_calculations()
      this.getInterval()
    },
    activeDate(dateObj) {
      this.activeDeliveryDate = new Date(dateObj._date)
      this.activeDay = dateObj._date
      this.futureDelivery(true)
      this.getInterval()
    },
    setFutureDateTime() {
      if (this.future_delivery) {
        if (this.activeDeliveryDate === '') {
          this.error = 'Please select a day'
        } else {
          if (
            this.active_slot == '' ||
            this.active_slot.time_from == undefined
          ) {
            this.error = 'Please select time slot'
          } else {
            if (typeof this.current_month != undefined) {
              this.activeDeliveryDate = this.date_time_format(
                this.activeDeliveryDate,
                'YYYY/MM/DD'
              )
            }
            let dateTime = {
              future_date: this.activeDeliveryDate,
              future_time: this.active_slot,
            }
            //future_order_datetime
            this.$store.commit('SET_FUTURE_DATE_TIME', dateTime)
            this.error = ''
            this.active_slot = ''
            this.future_delivery = true
            this.$bvModal.hide('delivery-time-table')
            this.future_order_format_date_time
          }
        }
      } else {
        this.$store.commit('SET_FUTURE_DATE_TIME', undefined)
        this.error = ''
        this.$bvModal.hide('delivery-time-table')
      }
    },
    ConvertMinutesToDay(num) {
      let h = Math.floor(num / 60)
      let d = Math.floor(h / 24)
      // h = h - d * 24
      // let m = Math.floor(num%60)
      // let s = ((num - d*24*60 - h*60 -m)*60).toFixed(2)

      return d
    },
    futureDelivery(state) {
      if (!this.currentStore) return false
      if (!state) this.setDefaultDate()
      this.future_delivery = state
      let time = this.deliveryTime(
        { delivery_duration: '0:' + this.currentDateTime.current_time },
        true
      )
      let store_open_time = this.deliveryTime(
        { delivery_duration: '0:' + this.currentStore.delivery_hours.opens_at },
        true
      )
      let store_close_time = this.deliveryTime(
        {
          delivery_duration: '0:' + this.currentStore.delivery_hours.closes_at,
        },
        true
      )
      let openAt = parseInt(
        this.deliveryTime({
          delivery_duration: '0:' + this.currentStore.delivery_hours.opens_at,
        })
      )
      let closedAt = parseInt(
        this.deliveryTime({
          delivery_duration: '0:' + this.currentStore.delivery_hours.closes_at,
        })
      )
      if (openAt >= closedAt) {
        let timeSplit = this.currentStore.delivery_hours.closes_at.split(':')
        let calcTime = openAt + closedAt + 12 + (12 - openAt)
        store_close_time = calcTime * 60 + parseInt(timeSplit[1])
      }
      if (this.currentStore.delivery_hours.all_day_long) {
        store_close_time = 24 * 60
      }
      store_close_time =
        parseInt(store_close_time) -
        parseInt(this.deliveryTime(this.currentStore, true))
      // store_open_time = parseInt(store_open_time) + parseInt(this.deliveryTime(this.currentStore, true))
      if (
        (time > store_open_time && time < store_close_time) ||
        (time < closedAt * 60 && time < store_close_time)
      ) {
        this.is_store_open = true
      } else if (
        store_open_time > time &&
        !this.currentStore.delivery_hours.all_day_long
      ) {
        // if (time < store_close_time) {
        //   this.is_store_open = true
        // } else {
        this.is_store_open = false
        // }
      }
    },
    setDefaultDate() {
      if (this.deliveryDate.length) {
        this.activeDeliveryDate = this.deliveryDate[0]._date
        this.activeDay = this.deliveryDate[0]._date
        this.getInterval()
      }
    },
    timeConvert(time, timeKnown, separator = ':') {
      if (!time) return ''
      let timeSplit = time.split(separator)
      if (timeKnown) this.hoursCalculation[timeKnown] = timeSplit[0]
      return parseInt(timeSplit[0]) * 60 + parseInt(timeSplit[1])
    },
    getInterval() {
      if (!this.currentStore) return false
      let startTime = 0
      let closedTime = 0
      let interval = (this.hoursCalculation['interval'] = this.deliveryTime(
        this.currentStore,
        true
      ))
      let activeDate = this.convertDateTimeTimezone(this.activeDeliveryDate)
      let store_date_time = Object.assign({}, this.currentDateTime)
      let store_current_time = this.timeConvert(store_date_time.current_time)
      this.days_to_delivery = this.ConvertMinutesToDay(interval)
      if (store_date_time && this.days_to_delivery >= 1) {
        let d = new Date(store_date_time.current_date)
        let set_day = d.getDate() + this.days_to_delivery
        d.setDate(set_day)
        store_date_time = this.convertDateTimeTimezone(d)
      }
      if (store_date_time) {
        const current_date_store = new Date(store_date_time.current_date)
        const current_date_active = new Date(activeDate.current_date)
        if (current_date_store > current_date_active && interval >= 1440) {
          this.time_slots = []
          return false
        }
      }

      // const diffTime = Math.abs(current_date_active - current_date_store)
      // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      /*if (store_date_time.current_date == activeDate.current_date && interval >= 1440) {
        this.days_to_delivery = this.ConvertMinutesToDay(interval)
        this.time_slots = []
        return false
      }*/
      if (this.currentStore && this.currentStore.delivery_hours) {
        if (this.currentStore.delivery_hours.all_day_long) {
          startTime = 0
          closedTime = 24 * 60
        } else {
          startTime = this.timeConvert(
            this.currentStore.delivery_hours.opens_at,
            'opens_at'
          )
          closedTime = this.timeConvert(
            this.currentStore.delivery_hours.closes_at,
            'closes_at'
          )
        }
      }
      /* below section added if time starts from morning 10AM to next day 4AM etc..*/
      let openAt = parseInt(this.hoursCalculation['opens_at'])
      let closedAt = parseInt(this.hoursCalculation['closes_at'])
      let close_time_after_midnight = 0
      let start_time_after_midnight = 0
      if (openAt >= closedAt) {
        start_time_after_midnight = 24 * 60
        let timeSplit = this.currentStore.delivery_hours.closes_at.split(':')
        let calcTime = openAt + 12 + (12 - openAt)
        close_time_after_midnight = openAt + closedAt + 12 + (12 - openAt)
        // startTime += openAt
        closedTime = calcTime * 60 + parseInt(timeSplit[1])
        close_time_after_midnight =
          close_time_after_midnight * 60 + parseInt(timeSplit[1])
      }
      // eslint-disable-next-line no-console
      // console.log(startTime, closedTime, 'closedTime')
      let time_slots = []
      let time_slots_md = []
      let occupied = null
      let hh = 0,
        mm = 0,
        i = 0,
        j = 0,
        ap = ['AM', 'PM'] // AM-PM

      /*for (let i = startTime; i <= closedTime; i = i + interval) {
        this.time_slots.push(i)
      }*/
      let time_24_to_hours = ''
      if (interval >= 1440) {
        interval = 60
      }
      store_current_time += interval
      if (!this.currentStore.fixed_delivery_time_slots) {
        interval = 5
      }
      // let time_24_to_hours = ''
      for (i; startTime < closedTime; i++) {
        if (close_time_after_midnight && j === 0) {
          let setAP_from_md = ''
          let time_from_md = ''
          let time_from_md_12 = ''
          let time_24_to_hours_md = 0
          let time_24_to_hours_md_12 = 0
          let start_time_interval_md = 0
          let setAP_to_md = ''
          let time_to_md = ''
          let hh_md = 0,
            mm_md = 0,
            hh_md_12 = 0,
            mm_md_12 = 0
          for (j; start_time_after_midnight < close_time_after_midnight; j++) {
            hh_md = Math.floor(start_time_after_midnight / 60) // getting hours of day in 0-24 format
            mm_md = start_time_after_midnight % 60 // getting minutes of the hour in 0-55 format

            hh_md_12 = Math.floor((start_time_after_midnight - interval) / 60) // getting hours of day in 0-24 format
            mm_md_12 = (start_time_after_midnight - interval) % 60 // getting minutes of the hour in 0-55 format

            setAP_from_md =
              typeof ap[Math.floor(hh_md / 12)] === 'undefined'
                ? 'AM'
                : ap[Math.floor(hh_md / 12)]
            time_from_md =
              ('0' + (hh_md % 12)).slice(-2) +
              ':' +
              ('0' + mm_md).slice(-2) +
              ' ' +
              setAP_from_md

            time_from_md_12 =
              ('0' + (hh_md_12 % 12)).slice(-2) +
              ':' +
              ('0' + mm_md_12).slice(-2) +
              ' PM'

            /*time to*/
            start_time_interval_md =
              start_time_after_midnight + parseInt(interval)
            hh_md = Math.floor(start_time_interval_md / 60) // getting hours of day in 0-24 format
            mm_md = start_time_interval_md % 60 // getting minutes of the hour in 0-55 format
            setAP_to_md =
              typeof ap[Math.floor(hh_md / 12)] === 'undefined'
                ? 'AM'
                : ap[Math.floor(hh_md / 12)]
            time_to_md =
              ('0' + (hh_md % 12)).slice(-2) +
              ':' +
              ('0' + mm_md).slice(-2) +
              ' ' +
              setAP_to_md

            time_24_to_hours_md = hh_md - 24 + ':' + mm_md
            time_24_to_hours_md_12 = hh_md_12 + ':' + mm_md_12
            let new_close_time_md =
              parseInt(close_time_after_midnight) - parseInt(interval)
            if (
              store_date_time &&
              activeDate &&
              new_close_time_md >= start_time_after_midnight
            ) {
              if (store_date_time.current_date == activeDate.current_date) {
                let time_slot_time = this.timeConvert(time_24_to_hours_md)
                if (time_slot_time > store_current_time) {
                  time_slots_md.push({
                    time_from: time_from_md,
                    time_to: time_to_md,
                    occupied: occupied,
                    time_24_from_hours: time_24_to_hours_md,
                  }) // pushing data in array in [00:00 - 12:00 AM/PM format]
                }
              } else {
                if (time_from_md == '00:00 AM') {
                  time_slots_md.push({
                    time_from: time_from_md_12,
                    time_to: time_from_md,
                    occupied: '00:00',
                    time_24_from_hours: time_24_to_hours_md_12,
                  })
                } // pushing data in array in [00:00 - 12:00 AM/PM format]
                time_slots_md.push({
                  time_from: time_from_md,
                  time_to: time_to_md,
                  occupied: occupied,
                  time_24_from_hours: time_24_to_hours_md,
                }) // pushing data in array in [00:00 - 12:00 AM/PM format]
              }
            }
            start_time_after_midnight = start_time_interval_md
          }
        }

        hh = Math.floor(startTime / 60) // getting hours of day in 0-24 format
        mm = startTime % 60 // getting minutes of the hour in 0-55 format

        let setAP_from =
          typeof ap[Math.floor(hh / 12)] === 'undefined'
            ? 'AM'
            : ap[Math.floor(hh / 12)]
        let time_from =
          ('0' + (hh % 12)).slice(-2) +
          ':' +
          ('0' + mm).slice(-2) +
          ' ' +
          setAP_from

        /*time to*/
        let start_time_interval = startTime + parseInt(interval)
        hh = Math.floor(start_time_interval / 60) // getting hours of day in 0-24 format
        mm = start_time_interval % 60 // getting minutes of the hour in 0-55 format
        let setAP_to =
          typeof ap[Math.floor(hh / 12)] === 'undefined'
            ? 'AM'
            : ap[Math.floor(hh / 12)]
        let time_to =
          ('0' + (hh % 12)).slice(-2) +
          ':' +
          ('0' + mm).slice(-2) +
          ' ' +
          setAP_to

        time_24_to_hours = hh + ':' + mm
        // here is the right
        // time_24_to_hours = hh + ':' + mm
        // occupied = this.tableBookedStatus.includes(timeSlot)
        let new_close_time = parseInt(closedTime) - parseInt(interval)
        if (
          store_date_time &&
          activeDate &&
          new_close_time >= startTime &&
          time_to !== '00:00 AM'
        ) {
          if (store_date_time.current_date == activeDate.current_date) {
            let time_slot_time = this.timeConvert(time_24_to_hours)
            if (time_slot_time > store_current_time) {
              time_slots.push({
                time_from: time_from,
                time_to: time_to,
                occupied: occupied,
                time_24_from_hours: time_24_to_hours,
              }) // pushing data in array in [00:00 - 12:00 AM/PM format]
            }
          } else {
            time_slots.push({
              time_from: time_from,
              time_to: time_to,
              occupied: occupied,
              time_24_from_hours: time_24_to_hours,
            }) // pushing data in array in [00:00 - 12:00 AM/PM format]
          }
        }
        startTime = start_time_interval
      }
      //console.log(time_slots, 'time_slotss', time_slots_md)
      this.time_slots = time_slots_md.concat(time_slots)
    },
    callDate() {
      this.deliveryDate = []
      let current_date = new Date()
      this.current_month = this.months[current_date.getMonth()]
      this.current_year = current_date.getFullYear()
      this.days_in_month = new Date(
        this.current_year,
        current_date.getMonth() + 1,
        0
      ).getDate()
      this.days_calculations()
      this.setDefaultDate()
    },
    days_calculations() {
      let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      // let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      let months = this.months
      let i = 0
      let current_month_index = this.months.indexOf(this.current_month)
      // let d = new Date(new Date().getTime() + i * 24 * 60 * 60 * 1000)
      // d =  d(d.getTime() + i * 24 * 60 * 60 * 1000)
      for (i; i < this.days_in_month; i++) {
        let d = new Date()
        let current_month = d.getMonth()
        let current_year = d.getFullYear()
        d.setMonth(current_month_index)
        d.setFullYear(this.current_year)
        if (
          current_month_index > current_month ||
          this.current_year > current_year
        )
          d.setDate(1)
        d = new Date(d.getTime() + i * 24 * 60 * 60 * 1000)
        if (i < d.getDate()) {
          this.deliveryDate.push({
            // day: i == 0 ? 'Today' : days[d.getDay()],
            day: days[d.getDay()],
            dt: d.getDate() < 10 ? '0' + d.getDate() : d.getDate(),
            month: months[d.getMonth()],
            _date:
              days[d.getDay()] +
              ', ' +
              (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) +
              ' ' +
              months[d.getMonth()] +
              ' ' +
              d.getFullYear(),
          })
        }
      }
    },
    callTime() {
      let endTime = new Date()
      endTime.setHours(endTime.getHours() + 1)
    },
    findTime(date) {
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'pm' : 'am'
      hours = hours % 12
      hours = hours ? hours : 12
      minutes = minutes < 10 ? '0' + minutes : minutes
      return hours + ':' + minutes + ' ' + ampm
    },
    /**
     * scrollTo - Horizontal Scrolling
     * @param {(HTMLElement ref)} element - Scroll Container
     * @param {number} scrollPixels - pixel to scroll
     * @param {number} duration -  Duration of scrolling animation in millisec
     */
    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft
      // Condition to check if scrolling is required
      if (
        !(
          (scrollPos === 0 || scrollPixels > 0) &&
          (element.clientWidth + scrollPos === element.scrollWidth ||
            scrollPixels < 0)
        )
      ) {
        // Get the start timestamp
        const startTime =
          'now' in window.performance ? performance.now() : new Date().getTime()

        // eslint-disable-next-line no-inner-declarations
        function scroll(timestamp) {
          //Calculate the timeelapsed
          const timeElapsed = timestamp - startTime
          //Calculate progress
          const progress = Math.min(timeElapsed / duration, 1)
          //Set the scrolleft
          element.scrollLeft = scrollPos + scrollPixels * progress
          //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
          if (timeElapsed < duration) {
            //Request for animation
            window.requestAnimationFrame(scroll)
          } else {
            return
          }
        }
        //Call requestAnimationFrame on scroll function first time
        window.requestAnimationFrame(scroll)
      }
    },
    swipeLeft() {
      const content = this.$refs.content
      this.scrollTo(content, -250, 800)
    },
    swipeRight() {
      const content = this.$refs.content
      this.scrollTo(content, 250, 800)
    },
    swipeLeftTime() {
      const content = this.$refs.slotTiming
      this.scrollTo(content, -250, 800)
    },
    swipeRightTime() {
      const content = this.$refs.slotTiming
      this.scrollTo(content, 250, 800)
    },
    swipeLeftMonth() {
      const content = this.$refs.slotMonth
      this.scrollTo(content, -250, 800)
    },
    swipeRightMonth() {
      const content = this.$refs.slotMonth
      this.scrollTo(content, 250, 800)
    },
  },
  mounted() {
    this.callTime()
    this.callDate()
    this.getInterval()
    this.futureDelivery(true)
    setInterval(() => {
      this.callDate()
      this.getInterval()
    }, 5000 * 60)
  },
}
</script>
<style lang="scss" scoped>
.modal-content {
  .modal-header {
    //border-bottom: none;
    .modal-title {
      font-weight: bold;
      line-height: $px22;
      letter-spacing: 0.7px;
    }
  }
  //.modal-header,
  .modal-body {
    padding: unset !important;
  }
  .modal-footer {
    display: flex;
    text-align: center;
    padding: $px15
      calc(#{$px15} + (30 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
    box-shadow: 0px -$px4 $px34 rgba($black, 0.07);
    border-top: none;
    .btn {
      padding: calc(#{$px8} + (15 - 8) * ((100vw - #{$px320}) / (1920 - 320)))
        $px5;
      width: $px100;
    }
  }
}
.pastmonth {
  opacity: 0.3;
  pointer-events: none;
}
.month_date {
  display: flex;
  justify-content: center;
  margin-top: 0;
  margin-bottom: 0;
  font-weight: bold;
}
.date-schedule {
  .date-card {
    display: flex;
    align-items: center;
    width: 90%;
    overflow: auto;
    padding: $px10;

    li {
      padding: calc(
        #{$px10} + (15 - 10) * ((100vw - #{$px320}) / (1920 - 320))
      );
      box-shadow: 0 $px4 $px24 rgba($black, 0.07);
      border-radius: $px4;
      text-align: center;
      width: 100%;
      @media (max-width: 575px) {
        min-width: $px70;
      }
      border: $px1 solid $transparent;
      transition: all 0.5s ease;
      cursor: pointer;
      &.active {
        background-color: $color-primary;
        border: $px1 solid $color-primary;
        h4,
        h6,
        small,
        h2 {
          color: $white;
        }
      }
      &:hover {
        border: $px1 solid $color-primary;
        transition: all 0.5s ease;
      }
      + li {
        margin-left: calc(
          #{$px10} + (15 - 10) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
      h4 {
        font-weight: 400 !important;
        //margin-bottom: $px10 !important;
      }
      h2 {
        font-size: calc(
          #{$px18} + (36 - 18) * ((100vw - #{$px320}) / (1920 - 320))
        );
        line-height: calc(
          #{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320))
        );
        letter-spacing: 0.01em;
        color: $font-color;
        font-weight: 400;
        margin-bottom: 0;
      }
    }
  }
}
.desired-time {
  margin-top: calc(#{$px10} + (50 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
  .box-checkbox {
    overflow: auto;
    ul {
      flex-wrap: nowrap;
      margin: 0;
      li {
        .delivery-label {
          width: 100%;
        }
        .time-labels {
          min-width: $px90;
          @media (max-width: 575px) {
            width: 100%;
          }
        }
        label {
          margin-bottom: 0;
          position: relative;
          cursor: pointer;
          .radio_animated {
            position: absolute;
            right: 0;
            margin-right: $px6;
            margin-top: $px5;
            opacity: 0;
            &:after {
              border-radius: $px2;
              background-color: $white;
              border: none;
            }
            &:before {
              transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
              transform: rotate(-45deg) scale(0, 0);
              left: $px3;
              top: $px1;
              z-index: 1;
              width: 0.75rem;
              height: 0.375rem;
              border: $px2 solid $white;
              border-top-style: none;
              border-right-style: none;
              background: $transparent;
              border-radius: 0;
            }
            &:checked {
              opacity: 0;
              &:after {
                background-color: $color-primary;
              }
              &:before {
                transform: rotate(-45deg) scale(1, 1);
              }
              ~ li {
                border: $px2 solid $color-primary;
                transition: all 0.5s ease;
                color: $color-primary;
              }
            }
          }
          span {
            padding: calc(
              #{$px2} + (15 - 8) * ((100vw - #{$px320}) / (1920 - 320))
            );
            /*border: $px2 solid $light-border;*/
            display: block;
            border-radius: $px4;
            transition: all 0.5s ease;
            font-weight: 600;
            font-size: calc(
              #{$px13} + (16 - 14) * ((100vw - #{$px320}) / (1920 - 320))
            );
            line-height: $px19;
            text-align: center;
            letter-spacing: 0.02em;
          }
        }
        &.col-sm-6 {
          &:nth-child(odd) {
            padding: 0;
          }
          &:nth-child(even) {
            padding-right: 0;
            @media (max-width: 575px) {
              padding: 0;
              margin-top: 10px;
            }
          }
        }
        max-width: 100%;
      }
    }
    .timing-soon {
      padding-top: calc(
        #{$px8} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );
      /*margin-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );*/
      //border-top: $px1 solid $light-border;
      height: $px50;
      text-align: center;
    }
    .timing-checkbox {
      /*padding-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );*/
      /*margin-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );
      border-top: $px1 solid $light-border;*/
      //max-height: $px346;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      li {
        margin: 0 $px3;
        border: $px2 solid $light-border;
        background: $light-sky;
        border-radius: $px4;
        &.active {
          background-color: $color-primary;
          border: $px2 solid $color-primary;
          color: $white;
        }
        label {
          span {
            /*border: $px2 solid $light-border;
            background: $light-sky;*/
          }
          .radio_animated {
            &:after {
              background: $light-font;
            }
            &:checked {
              ~ span {
                //background-color: $color-primary;
                //border: $px1 solid $color-primary;
                //color: $white;
              }
            }
            &:disabled {
              ~ span {
                color: rgba(var(--color-font-color-source), 0.3);
              }
            }
          }
        }
        margin-top: $px15;
        + li {
          //margin-top: $px15;
          + li {
            //margin-top: $px15;
          }
        }
      }
    }
  }
  h4 {
    margin-bottom: calc(
      #{$px8} + (10 - 8) * ((100vw - #{$px320}) / (1920 - 320))
    ) !important;
  }
}

.desired-time-selection {
  margin-top: calc(#{$px20} + (50 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
  @media (max-width: 575px) {
    .margin-mobile {
      margin-top: $px10;
    }
  }
  .box-checkbox {
    ul {
      margin: 0;
      li {
        .delivery-label {
          width: 100%;
        }
        .time-labels {
          min-width: 220px;
          @media (max-width: 575px) {
            width: 100%;
          }
        }
        label {
          margin-bottom: 0;
          position: relative;
          cursor: pointer;
          .radio_animated {
            position: absolute;
            right: 0;
            margin-right: $px6;
            margin-top: $px5;
            opacity: 0;
            &:after {
              border-radius: $px2;
              background-color: $white;
              border: none;
            }
            &:before {
              transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
              transform: rotate(-45deg) scale(0, 0);
              left: $px3;
              top: $px1;
              z-index: 1;
              width: 0.75rem;
              height: 0.375rem;
              border: $px2 solid $white;
              border-top-style: none;
              border-right-style: none;
              background: $transparent;
              border-radius: 0;
            }
            &:checked {
              opacity: 0;
              &:after {
                background-color: $color-primary;
              }
              &:before {
                transform: rotate(-45deg) scale(1, 1);
              }
              ~ span {
                border: $px2 solid $color-primary;
                transition: all 0.5s ease;
                color: $color-primary;
              }
            }
          }
          span {
            padding: calc(
              #{$px8} + (15 - 8) * ((100vw - #{$px320}) / (1920 - 320))
            );
            border: $px2 solid $light-border;
            display: block;
            border-radius: $px4;
            transition: all 0.5s ease;
            font-weight: 600;
            font-size: calc(
              #{$px14} + (16 - 14) * ((100vw - #{$px320}) / (1920 - 320))
            );
            line-height: $px19;
            text-align: center;
            letter-spacing: 0.02em;
          }
        }
        &.col-sm-6 {
          &:nth-child(odd) {
            padding: 0;
          }
          &:nth-child(even) {
            padding-right: 0;
            @media (max-width: 575px) {
              padding: 0;
              margin-top: 10px;
            }
          }
        }
      }
    }
    .timing-soon {
      padding-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );
      margin-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );
      border-top: $px1 solid $light-border;
      height: $px50;
    }
    .timing-checkbox {
      /*padding-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );*/
      margin-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );
      border-top: $px1 solid $light-border;
      height: $px346;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      li {
        label {
          span {
            border: $px2 solid $light-border;
            background: $light-sky;
          }
          .radio_animated {
            &:after {
              background: $light-font;
            }
            &:checked {
              ~ span {
                background-color: $white;
              }
            }
            &:disabled {
              ~ span {
                color: rgba(var(--color-font-color-source), 0.3);
              }
            }
          }
        }
        margin-top: $px15;
        + li {
          //margin-top: $px15;
          + li {
            //margin-top: $px15;
          }
        }
      }
    }
  }
  h4 {
    margin-bottom: calc(
      #{$px8} + (10 - 8) * ((100vw - #{$px320}) / (1920 - 320))
    ) !important;
  }
}
.btn-style-arrow {
  border: none;
  background: no-repeat;
}
.edit-profile .modal-header {
  border: unset;
  padding: $px14 $px20 !important;
  box-shadow: 0 0 $px11 rgba(33, 33, 33, 0.2);
}
.body-rtl {
  .modal-body {
    ul {
      direction: ltr;
    }
  }
  .modal-content {
    .modal-header {
      .modal-title {
        text-align: right;
      }
    }
  }
  .date-schedule {
    span {
      float: unset;
    }
    .date-card {
      /*li {
          +li {
            margin-left: unset;
            margin-right: calc(
          #{$px10} + (15 - 10) * ((100vw - #{$px320}) / (1920 - 320))
        );
          }
        }*/
    }
  }
}
</style>
